// see https://gist.github.com/ziggi/2f15832b57398649ee9b
export default function getParents(
  el: Element,
  selector: string | null = null,
): Element[] {
  if (el) {
    const elements: Element[] = [];
    let elem: Element | null = el;
    while ((elem = elem.parentElement) !== null) {
      if (elem.nodeType !== Node.ELEMENT_NODE) {
        continue;
      }
      if (selector == null || elem.matches(selector)) {
        elements.push(elem);
      }
    }
    return elements;
  } else {
    return [];
  }
}
